module.exports = __webpack_public_path__ + "img/carryall_packed_thumb.8cb13aec.jpg";